import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
import { reactive, getCurrentInstance, onMounted } from 'vue';
import Keys from '@/constant/key';
import { useStore } from '@/store/index';
import { joinParams } from '@/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryBottom',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const store = useStore();
    const filterData = reactive({
      id: '',
      from: '',
      to: ''
    });
    const couponList = ref([]);
    const onExport = () => {
      const params = {
        ...filterData,
        user_id: store.state.user.userInfo.id
      };
      window.open(`${Keys.baseUrl}/sys/admin/outputCoupons?${joinParams(params)}&is_export=1`);
    };
    const getCouponList = async () => {
      const {
        code,
        data,
        msg
      } = await proxy.$http.get('/sys/admin/getCouponlist');
      if (code != 200) {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
      couponList.value = data;
    };
    onMounted(() => {
      getCouponList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        class: "mb15",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "card-header",
          style: {
            "font-size": "14px",
            "font-weight": "bold"
          }
        }, [_createElementVNode("span", null, "商户卷码核销记录")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true,
          class: "filter-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "电子券："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: filterData.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterData.id = $event),
              placeholder: "全部",
              class: "",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "全部",
                value: ''
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(couponList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开始时间："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: filterData.from,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filterData.from = $event),
              type: "date",
              placeholder: "选择开始日期",
              class: "filter-item date-input",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "结束时间："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: filterData.to,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filterData.to = $event),
              type: "date",
              placeholder: "选择结束日期",
              class: "filter-item date-input",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: onExport,
              class: "export-btn"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("导出")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});